<div class="dashboard-container">
  <div class="header">
    <div class="title">
      <span class="material-symbols-rounded text-2xl text-[#5b774a]"
        >analytics</span
      >
      <p class="m-0 text-[#4b5563] text-xl font-medium">
        {{ "admin.dashboard.title" | translate }}
      </p>
    </div>
    <div class="flex items-center gap-2">
      @if (isFilterApplied) {
        <button
          (click)="clearFilters()"
          class="text-sm text-[#6A7381] hover:underline"
        >
          {{ "admin.dashboard.clearFilter" | translate }}
        </button>
      }
      <button
        (click)="downloadStatsCsv()"
        [disabled]="
          (isDownloadingCompanyStats$ | async) ||
          (isDownloadingCompaniesStats$ | async)
        "
        class="flex items-center gap-2 border text-[#6A7381] border-[#6A7381] rounded-md px-2 text-sm"
      >
        <p class="!m-0">{{ "admin.dashboard.downloadCsv" | translate }}</p>
        @if (
          (isDownloadingCompanyStats$ | async) ||
          (isDownloadingCompaniesStats$ | async)
        ) {
          <span
            class="loader-border w-4 h-4 border-2 border-t-transparent rounded-full animate-spin"
          ></span>
        } @else {
          <span class="material-symbols-rounded text-[#5b774a] scale-90">
            download
          </span>
        }
      </button>
      <div class="relative w-52">
        <input
          (change)="onDateRangeChange($event)"
          [alwaysShowCalendars]="true"
          [autoApply]="true"
          [drops]="'down'"
          [linkedCalendars]="true"
          [locale]="datepickerLocale"
          [opens]="'left'"
          [showCancel]="false"
          [showClearButton]="true"
          [showDropdowns]="true"
          class="form-control cursor-pointer w-full border rounded text-sm"
          ngxDaterangepickerBootstrap
          placeholder="{{ 'admin.dashboard.filterByDate' | translate }}"
          readonly
          type="text"
        />
        <div
          class="absolute inset-y-0 right-2 flex items-center pointer-events-none"
        >
          <span class="material-symbols-rounded scale-75 text-[#6A7381]"
            >date_range</span
          >
        </div>
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      'lg:grid-cols-5': environment.isSuperAdmin,
      'lg:grid-cols-4': !environment.isSuperAdmin,
    }"
    class="grid gap-4 grid-cols-1 sm:grid-cols-2"
  >
    @if (environment.isSuperAdmin) {
      <div class="stat-card">
        <span class="material-symbols-rounded card-icon companies">
          domain
        </span>
        <div class="card-text">
          @if (dashboardStats$ | async; as stats) {
            <p class="card-count">{{ stats.companyCount }}</p>
          }
          <span class="card-title">{{
            "admin.dashboard.cards.totalCompanies" | translate
          }}</span>
        </div>
      </div>
    }
    @if (!environment.isSuperAdmin) {
      <div class="stat-card lg:col-span-2">
        <span class="material-symbols-rounded card-icon billing-total">
          paid
        </span>
        <div class="card-text">
          @if (currentBilling$ | async; as currentBilling) {
            <div class="flex justify-between items-center gap-36">
              <div class="flex flex-col">
                <div class="flex items-center gap-3">
                  <p class="card-count">
                    {{
                      currentBilling.billing.totalPrice
                        | currency
                          : currencyCode
                          : "symbol"
                          : "1.2-2"
                          : currentLang
                    }}
                  </p>
                  <span
                    class="border px-1 border-solid border-[#6A7381] text-[#6A7381] rounded-md"
                    >{{ currentBilling.fileCount }}
                    {{
                      "admin.dashboard.cards.billing.files" | translate
                    }}</span
                  >
                </div>
                <span class="card-title"
                  >{{
                    "admin.dashboard.cards.billing.totalPrice" | translate
                  }}
                  ({{ currentBilling.startDate | date: "dd/MM/yyyy" }} -
                  {{ currentBilling.endDate | date: "dd/MM/yyyy" }})</span
                >
              </div>
              <button
                (click)="downloadMonthlyBillingCsv()"
                class="flex items-center gap-2 border text-[#6A7381] border-[#6A7381] rounded-md px-2 text-sm self-start"
                [disabled]="isDownloadingMonthlyBilling$ | async"
              >
                <p class="!m-0">
                  {{ "admin.dashboard.downloadCsv" | translate }}
                </p>

                @if (isDownloadingMonthlyBilling$ | async) {
                  <span
                    class="loader-border w-4 h-4 border-2 border-t-transparent rounded-full animate-spin"
                  ></span>
                } @else {
                  <span
                    class="material-symbols-rounded text-[#5b774a] scale-90"
                  >
                    download
                  </span>
                }
              </button>
            </div>
          }
        </div>
      </div>
      <div class="stat-card lg:col-span-2">
        <span class="material-symbols-rounded card-icon billing-unitary">
          counter_1
        </span>
        <div class="card-text">
          @if (currentBilling$ | async; as currentBilling) {
            <p class="card-count">
              {{
                currentBilling.billing.pricePerFile
                  | currency: currencyCode : "symbol" : "1.2-2" : currentLang
              }}
            </p>
            <span class="card-title"
              >{{
                "admin.dashboard.cards.billing.unitaryPrice" | translate
              }}
              ({{ currentBilling.startDate | date: "dd/MM/yyyy" }} -{{
                currentBilling.endDate | date: "dd/MM/yyyy"
              }})</span
            >
          }
        </div>
      </div>
    }
    <div class="stat-card">
      <span class="material-symbols-rounded card-icon users"> groups </span>
      <div class="card-text">
        @if (dashboardStats$ | async; as stats) {
          <p class="card-count">{{ stats.userCount }}</p>
        }
        <span class="card-title">{{
          "admin.dashboard.cards.totalUsers" | translate
        }}</span>
      </div>
    </div>

    <div class="stat-card">
      <span class="material-symbols-rounded card-icon files"> task_alt </span>
      <div class="card-text">
        @if (dashboardStats$ | async; as stats) {
          <p class="card-count">{{ stats.fileCount }}</p>
        }
        <span class="card-title">{{
          "admin.dashboard.cards.totalFiles" | translate
        }}</span>
      </div>
    </div>

    <div class="stat-card">
      <img
        alt=""
        class="card-icon gerber"
        src="assets/images/Gerber1 1 1.svg"
      />
      <div class="card-text">
        @if (dashboardStats$ | async; as stats) {
          <p class="card-count">{{ stats.gerberCount }}</p>
        }
        <span class="card-title">{{
          "admin.dashboard.cards.gerber" | translate
        }}</span>
      </div>
    </div>

    <div class="stat-card">
      <img
        alt=""
        class="card-icon lectra"
        src="assets/images/lectra-icon 1.svg"
      />
      <div class="card-text">
        @if (dashboardStats$ | async; as stats) {
          <p class="card-count">{{ stats.lectraCount }}</p>
        }
        <span class="card-title">{{
          "admin.dashboard.cards.lectra" | translate
        }}</span>
      </div>
    </div>
  </div>

  @if (dashboardStats$ | async; as stats) {
    @if (chartData$ | async; as chart) {
      <div class="charts-container">
        <app-chart-card
          class="chart-donut"
          [data]="[stats.gerberCount, stats.lectraCount]"
          [labels]="['Gerber', 'Lectra']"
          [title]="'admin.dashboard.charts.byType' | translate"
          [defaultType]="'donut'"
          [showTypeSwitcher]="true"
          [distributed]="true"
        />

        <app-chart-card
          class="chart-bar"
          [series]="chart.series"
          [labels]="chart.labels"
          [title]="'admin.dashboard.charts.byPeriod' | translate"
          [defaultType]="'bar'"
          [distributed]="false"
        />
      </div>
    }
  }

  <div class="recent-activity">
    <p>{{ "admin.dashboard.recentConversions" | translate }}</p>
    @if (dashboardStats$ | async; as stats) {
      <ul>
        @for (recentFile of stats.recentFiles; track $index) {
          <li
            [innerHTML]="
              'admin.dashboard.recentEntryHtml'
                | translate
                  : {
                      date: dateUtils.formatIsoToDateTime(recentFile.createdAt),
                      user: recentFile.userName,
                      type: recentFile.fileType,
                      file: recentFile.originalFileName,
                    }
            "
          ></li>
        }
      </ul>
    }
  </div>
</div>
